import React from "react";
import IssueTypeForm from "../../../../../presentation/pages/developer/type-issue";

const MakeIssueType: React.FC = () => (
  <IssueTypeForm />
);

export default MakeIssueType;